import React, { useState, useEffect, useRef } from 'react';

type HamburgerMenuItem = {
  label: string;
  path?: string;
  onClick?: () => void;
};

interface HamburgerMenuProps {
  menuItems: HamburgerMenuItem[];
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ menuItems }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleItemClick = (item: HamburgerMenuItem) => {
    setIsOpen(false);
    if (item.onClick) {
      item.onClick();
    } else if (item.path) {
      window.location.href = item.path;
    }
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div ref={menuRef}>
      <button className="hamburger-icon" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>
      {isOpen && (
        <div className="dropdown-menu">
          <ul>
            {menuItems.map((item) => (
              <li key={`menu-item-${item.label}`}>
                <button onClick={() => handleItemClick(item)}>
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default HamburgerMenu;
